import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import "../css/SelectJobModal.css";

const SelectDropdown = ({ theme, type, header, isOpen, setIsOpen, list, returnData }) => {
    const [value, setValue] = useState("");
    const [error, setError] = useState("");
    const [selectionList, setSelectionList] = useState([]);

    const handleSubmit = () => {
        if (!value) {
            setError("No value selected!");
        } else {
            setError("");
            returnData(selectionList[value]); // Send selected object instead of just key
            setIsOpen(false);
        }
    };

    useEffect(() => {
        if (!type) return;
        if (!list) return;

        // filter list based on type
        if (type === "truck") {
            setSelectionList(list.filter((item) => item.type !== "TRAILER" && item.type !== "MHE"));
        } else if (type === "trailer") {
            setSelectionList(list.filter((item) => item.type === "TRAILER"));
        } else {
            setSelectionList(list);
        }
    }, [type, list]);


    return (
        <Modal
            id={theme}
            isOpen={isOpen}
            onRequestClose={() => setIsOpen(false)}
            ariaHideApp={false}
            style={{
                overlay: { zIndex: 99999, backgroundColor: 'rgba(0, 0, 0, 0.5)' },
                content: { margin: "auto", justifyContent: "center", display: "flex", backgroundColor: "transparent", border: "none", zIndex: 100000, height: "300px" }
            }}
        >
            <div className={`${theme} modal-container`}>
                <h2>{header}</h2>

                <div className="select-group">
                    <label htmlFor="valueSelect">
                        Select {header === 'Select Driver' ? 'Driver' : 'Vehicle'}:
                    </label>
                    <select
                        id="valueSelect"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                    >
                        <option value="">-- Select --</option>
                        {selectionList && Object.keys(selectionList).length > 0 ? (
                            Object.keys(selectionList).map((key) => {
                                const item = selectionList[key];
                                const vor = item?.vor?? false; // Check if vor is defined and true

                                return (
                                    <option key={key} value={key} disabled={vor}>
                                        {header === 'Select Driver'
                                            ? `${item.name} ${item.surname}`
                                            : item.reg}
                                        {vor && (
                                            <span style={{ color: 'red', fontWeight: 'bold' }}> (VOR)</span>
                                        )}
                                    </option>
                                );
                            })
                        ) : (
                            <option disabled>No options available</option>
                        )}
                    </select>

                </div>

                {error && <p className="error-message" style={{ background: 'transparent'}}>{error}</p>}

                <div className="button-group">
                    <button className="add-button" onClick={handleSubmit}>Submit</button>
                    <button className="close-button" onClick={() => setIsOpen(false)}>Close</button>
                </div>
            </div>
        </Modal>
    );
};

export default SelectDropdown;
